<template>
  <div class="flex flex-col sm:flex-row mb-4 items-center">
    <span class="isolate inline-flex h-min rounded-md shadow-sm mr-5">
      <button
        type="button"
        @click="setLogicalOperator('or')"
        class="
          relative
          inline-flex
          items-center
          rounded-l-md
          border border-gray-300
          px-1
          py-0.5
          text-xs
          font-base
          focus:z-10 focus:outline-none
        "
        :class="
          logicalOperator == 'or'
            ? 'bg-markencode-blue text-white'
            : 'bg-white text-gray-500 hover:bg-gray-50'
        "
      >
        oder
      </button>
      <button
        type="button"
        :disabled="wordAttributes.length < 2"
        @click="setLogicalOperator('and')"
        class="
          relative
          -ml-px
          inline-flex
          items-center
          rounded-r-md
          border border-gray-300
          px-1
          py-0.5
          text-xs
          font-base
          focus:z-10 focus:outline-none
        "
        :class="[
          wordAttributes.length < 2 ? 'opacity-50' : '',
          logicalOperator == 'and'
            ? 'bg-markencode-blue text-white'
            : 'bg-white text-gray-500 hover:bg-gray-50',
        ]"
      >
        und
      </button>
    </span>

    <ul v-if="wordCategories.length > 0" class="w-full">
      <li
        v-for="(category, idx) in wordCategories"
        :key="idx"
        @click="toggleCategory(category)"
        class="inline-flex items-center"
      >
        <span
          class="
            relative
            items-center
            rounded-full
            pl-2.5
            py-0.5
            text-xs
            font-base
            cursor-pointer
            bg-gray-400
            text-white
          "
          :class="
            numActiveAttributesInCategory(category) > 0
              ? 'pr-5 mr-3'
              : 'pr-2.5 mr-1'
          "
        >
          {{ category.name }}
          <span
            v-show="numActiveAttributesInCategory(category) > 0"
            class="
              absolute
              -top-2
              -right-2
              items-center
              rounded-full
              px-2
              py-0.5
              text-xs
              font-base
              cursor-pointer
              bg-markencode-blue
              text-white
            "
          >
            {{ numActiveAttributesInCategory(category) }}</span
          >
        </span>

        <ul
          v-if="
            category.attributes.length > 0 &&
            expandedCategories.includes(category.id)
          "
        >
          <li
            @click.stop="toggleAttribute(attribute)"
            v-for="(attribute, idx) in category.attributes"
            :key="idx"
            class="
              mb-1
              mr-1
              inline-flex
              items-center
              rounded-full
              px-2.5
              py-0.5
              text-xs
              font-base
              cursor-pointer
              hover:bg-gray-300
            "
            :class="
              isActiveAttribute(attribute)
                ? 'bg-markencode-blue text-white'
                : 'bg-gray-200 text-gray-800'
            "
          >
            {{ attribute.name }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { uniq } from 'lodash';

export default {
  props: {
    wordCategories: {
      required: true,
      default: [],
    },

    selectedWordAttributes: {
      required: true,
      default: Array,
    },

    selectedLogicalOperator: {
      required: false,
      default: 'or',
    },
  },

  data() {
    return {
      logicalOperator: this.selectedLogicalOperator || 'or',
      wordAttributes: this.selectedWordAttributes ? this.selectedWordAttributes.map(Number) : [],
      expandedCategories: [],
    };
  },

  watch: {
    wordAttributes: function() {
      if(this.wordAttributes.length < 2) {
        this.logicalOperator = 'or';
        this.$emit('logicalOperatorSet', this.logicalOperator);
      }
    },
  },

  methods: {
    setLogicalOperator(operator) {
      this.logicalOperator = operator;

      this.$emit('logicalOperatorSet', this.logicalOperator);
    },

    toggleCategory(toggledCategory) {
      if (this.expandedCategories.includes(toggledCategory.id)) {
        this.expandedCategories = this.expandedCategories.filter(
          (e) => e !== toggledCategory.id
        );

        // delete attributes of the category that is being collapsed.
        // maybe we do not need that anymore since we are now showing
        // how may attributes are selected per category.
        // let attributesToDelete = this.wordCategories
        //   .filter((category) => {
        //     return category.id == toggledCategory.id;
        //   })
        //   .map(function (val, idx) {
        //     return val.attributes || [];
        //   })[0]
        //   .map(({ id }) => id);

        // this.wordAttributes = this.wordAttributes.filter(
        //   (attributeId) => {
        //     return !attributesToDelete.includes(attributeId);
        //   }
        // );
      } else {
        this.expandedCategories.push(toggledCategory.id);
      }
    },

    toggleAttribute(attribute) {
      if (this.wordAttributes.includes(attribute.id)) {
        this.wordAttributes = this.wordAttributes.filter(
          (e) => e !== attribute.id
        );
      } else {
        this.wordAttributes.push(attribute.id);
      }

      this.wordAttributes = uniq(this.wordAttributes.map(Number));

      this.$emit('attributesToggled', this.wordAttributes.map(Number));
    },

    numActiveAttributesInCategory(activeCategory) {
      let attributes = this.wordCategories
        .filter((category) => {
          return category.id == activeCategory.id;
        })
        .map(function (val, idx) {
          return val.attributes || [];
        })[0]
        .map(({ id }) => id);

      return this.wordAttributes.filter((attributeId) => {
        return attributes.includes(attributeId);
      }).length;
    },

    isActiveAttribute(attribute) {
      if (this.wordAttributes.includes(attribute.id)) {
        return true;
      }

      return false;
    },
  },
};
</script>